<div class="layer-catalog">
    <ng-container>
        <div class="form-group" [formGroup]="searchInputForm">
            <div class="input-group filter-box">
                <div class="input-container">
                    <input class="input-group-input form-control" type="text" formControlName="searchInput"
                           placeholder="Filter by category name, layer name, or layer id." [(ngModel)]="searchText" />
                </div>
                <div class="icon-container">
                    <i class="icon-ui-filter"></i>
                </div>
            </div>
        </div>
        <div *ngIf="isLoading && !loadingLayers">
            <div class="loader is-active padding-leader-3 padding-trailer-3">
                <div class="loader-bars"></div>
                <div class="loader-text">Loading layer data from external servers...</div>
            </div>
        </div>
        <div *ngIf="!isLoading && loadingLayers">
            <div class="loader is-active padding-leader-3 padding-trailer-3">
                <div class="loader-bars"></div>
                <div class="loader-text">Loading layers to map...</div>
            </div>
        </div>
        <div class="reload-container" *ngIf="!isLoading && errorLoadingLayers && !loadingLayers">
            <p>{{ errorLoadingLayers }}</p>
            <p><button class="btn btn-primary" (click)="onActivate()">Reload</button></p>
        </div>
        <div class="canvas" *ngIf="!isLoading && filteredCatalogItems && !loadingLayers">
            <ul class="list-plain layer-list">
                <li class="clearfix" *ngFor="let catalogItem of filteredCatalogItems">
                    <mc-layer-catalog-item-ng [layerCatalogItem]="catalogItem" [layerItemType]="'External'"
                                              [multiSelectActive]="false" (checkChangedEvent)="itemSelectedChanged(catalogItem)">
                    </mc-layer-catalog-item-ng>
                </li>
            </ul>
        </div>
        <div class="add-layers">
            <button class="btn add-selected-layers" (click)="addSelectedLayers()" [disabled]="!selectedLayers.length || loadingLayers">
                Add Selected Layers
            </button>
            <button class="btn btn-clear cancel" (click)="close()" [disabled]="loadingLayers">Cancel</button>
            <span class="layers-selected">
                Layers Selected ({{ selectedLayers.length }})
            </span>
        </div>
    </ng-container>
</div>
